import { SupplierTruckDocumentType } from 'src/types/enums';

export const SUPPLIER_TRUCK_DOCUMENT_MAP = {
  [SupplierTruckDocumentType.Examination]: 'Keuring',
  [SupplierTruckDocumentType.Insurance]: 'Verzekering',
};
